import React from 'react'

const Footnote = props => {
  const createMarkup = text => {
    return { __html: text }
  }

  const footnotes = props.notes.map(d => {
    const ref = `#${d.id}-ref`
    return (
      <li id={d.id} key={d.id}>
        <span dangerouslySetInnerHTML={createMarkup(d.value)}></span>{' '}
        <a href={ref} aria-label='Back to content'>
          {' '}
          ↩
        </a>
      </li>
    )
  })

  return (
    <div className='footnotes-wrapper article-wrapper'>
      <hr></hr>
      <p className='footnotes-title'>Notes</p>
      <ol> {footnotes} </ol>
    </div>
  )
}

export default Footnote
